module.exports = __webpack_public_path__ + "img/20171229_172731.fc0487f0.jpg";